import React from "react";
import { FEATURES as features } from "../config/product";

const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative min-h-screen py-32 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-start justify-between mb-20 flex-wrap gap-8">
          <div className="max-w-xl">
            <span className="font-serif-accent text-[#ff9eeb] text-xl">— Ventajas</span>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.9] font-bold tracking-tighter mt-3">
              Carga y
              <br />
              <span className="holo-text">olvídate.</span>
            </h2>
          </div>
          <p className="font-body text-white/60 text-lg max-w-md md:mt-4 leading-relaxed">
            Enchufas, cargas y FullStop se encarga del resto. Cuando la batería
            llega al <span className="font-serif-accent text-white">100%</span>, corta la
            corriente por ti — sin apps, sin complicaciones.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {features.map((f, i) => {
            // Asymmetric layout
            const layouts = [
              "md:col-span-7 md:row-span-2",
              "md:col-span-5",
              "md:col-span-5",
              "md:col-span-7",
            ];
            return (
              <div
                key={f.title}
                data-testid={`feature-card-${i}`}
                className={`group glass rounded-3xl p-8 md:p-10 hover:-translate-y-1 hover:border-white/30 transition-all duration-500 cursor-pointer relative overflow-hidden ${layouts[i]}`}
              >
                <div className="absolute -inset-px rounded-3xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{
                    background: "radial-gradient(600px circle at var(--mx,50%) var(--my,50%), rgba(255,158,235,0.12), transparent 40%)",
                  }}
                />
                <div className="relative flex flex-col gap-6 h-full">
                  <div className="flex items-baseline gap-3">
                    <span className="font-display text-6xl md:text-7xl font-bold tracking-tighter holo-text">
                      {f.metric}
                    </span>
                    <span className="font-body text-xs text-white/50 uppercase tracking-widest">
                      {f.metricLabel}
                    </span>
                  </div>
                  <div className="mt-auto">
                    <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight mb-2">
                      {f.title}
                    </h3>
                    <p className="font-body text-white/60 text-sm leading-relaxed">
                      {f.body}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
